import * as ActionTypes from '../ActionTypes';

const initialState = {
    contractor_options: [],
    isLoading: false,
};

const ContractorReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.CONTRACTOR_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                contractor_options: [],
            };
        case ActionTypes.CONTRACTOR_ADD_REQUEST:
        case ActionTypes.CONTRACTOR_UPDATE_REQUEST:
        case ActionTypes.CONTRACTOR_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.CONTRACTOR_GET_SUCCESS:
        case ActionTypes.CONTRACTOR_ADD_SUCCESS:
        case ActionTypes.CONTRACTOR_UPDATE_SUCCESS:
        case ActionTypes.CONTRACTOR_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                contractor_options: action.payload?.data?.data
            };
        case ActionTypes.CONTRACTOR_GET_ERROR:
        case ActionTypes.CONTRACTOR_ADD_ERROR:
        case ActionTypes.CONTRACTOR_UPDATE_ERROR:
        case ActionTypes.CONTRACTOR_DELETE_ERROR:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}

export default ContractorReducer;